import cx from 'classnames';
import React, { Component } from 'react';
import { Text, Popover } from 'wix-style-react';
import { Heart, HeartFilled } from 'wix-ui-icons-common';

import { biLogSafe } from '../../../universal/biService';
import s from './Name.scss';

class Name extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPopoverTooltipShown: false
    };
  }

  setPopoverTooltipState = state => {
    this.setState({
      isPopoverTooltipShown: state
    });
  };

  handleGetItClicked = e => {
    e.stopPropagation();
    const { onDomainClicked, domain, referralInfo } = this.props;
    const { name } = this.state;
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorFinalActionClick', {
        origin: referralInfo,
        pageName: 'Names List',
        actionName: 'Secure It now',
        additionalInfo: JSON.stringify({ businessName: name, domainName: domain })
      });
    });
    onDomainClicked(e, domain);
  };

  onLikeClicked = (e, index) => {
    const { onLikeClicked, referralInfo, domain } = this.props;
    const { name } = this.state;
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorButtonClick', {
        origin: referralInfo,
        pageName: 'Names List',
        buttonName: 'LIKE',
        additionalInfo: JSON.stringify({ Name: name, domain })
      });
    });
    onLikeClicked(e, index);
  };

  getIconButton = () => {
    const { index, isLiked, onLikeClicked } = this.props;
    const iconButton = isLiked ? (
      <HeartFilled onClick={e => onLikeClicked(e, index)} className={s.iconsLogo} style={{ color: '#3899ec' }} size={18} />
    ) : (
      <Heart onClick={e => onLikeClicked(e, index)} className={s.iconsLogo} size={18} />
    );
    return iconButton;
  };

  getSuggestedName = () => {
    const { expand, name } = this.props;
    const suggestedName = (
      <div
        onMouseEnter={() => this.setPopoverTooltipState(true)}
        onMouseLeave={() => this.setPopoverTooltipState(false)}
        className={cx(s.nameBox, { [s.expand]: expand })}
      >
        <div className={s.nameText}>
          <Text size="small">{name}</Text>
        </div>
        <div className={s.likeButton}>{this.getIconButton()}</div>
      </div>
    );
    return suggestedName;
  };

  wrapSuggestedNameWithTooltip = () => {
    const { t, expand } = this.props;
    const { isPopoverTooltipShown } = this.state;
    return (
      <Popover maxWidth={300} shown={isPopoverTooltipShown && !expand} appendTo="window" flip={false} placement="top" showArrow theme="dark">
        <Popover.Element>{this.getSuggestedName()}</Popover.Element>
        <Popover.Content>
          <div
            style={{
              padding: '12px 24px',
              textAlign: 'center'
            }}
          >
            <Text size="small" light>
              {t('BNG_NAMES_LIST_ITEM_TOOLTIP')}
            </Text>
          </div>
        </Popover.Content>
      </Popover>
      // <Tooltip
      //   // appendTo="viewport"
      //   content={t('BNG_NAMES_LIST_ITEM_TOOLTIP')}
      //   placement="top"
      //   maxWidth={300}
      //   size="small"
      // >
      //   {this.getSuggestedName()}
      // </Tooltip>
    );
  };
  getSuggestedNameForMobileVersion = () => {
    const { expand, name, onNameLineClicked, index } = this.props;
    const suggestedName = (
      <div onClick={() => onNameLineClicked(index, name)} className={cx(s.nameBox, { [s.expand]: expand })}>
        <div className={s.nameText}>
          <Text size="small">{name}</Text>
        </div>
        <div className={s.likeButton}>{this.getIconButton()}</div>
      </div>
    );
    return suggestedName;
  };

  getNameForMobileVersion = () => {
    return this.getSuggestedNameForMobileVersion();
  };

  renderNameByScreenType = screenType => {
    if (screenType === 'mobile') {
      return this.getNameForMobileVersion();
    } else {
      return this.wrapSuggestedNameWithTooltip();
    }
  };
  render() {
    const { screenType } = this.props;
    return this.renderNameByScreenType(screenType);
  }
}

export default Name;
